import React, { useContext, useEffect, useState } from "react";
import SelectArrow from "../../../assets/images/select-arrow.svg";
import ClearSearch from "../../../assets/images/clear-search.svg";
import SelectedTick from "../../../assets/images/selected-tick.svg";
import styled from "styled-components";
import LayoutContext from "../../../contexts/LayoutContext";
import GenderDropDownComponent from "./SearchComponent/Gender";
import AgeGroup from "./SearchComponent/AgeGroup";
import { useNavigate } from "react-router-dom";
import Color from "./SearchComponent/Color";
import Brand from "./SearchComponent/Brand";
import ProductType from "./SearchComponent/ProductType";
import ProductCategory from "./SearchComponent/ProductCategory";
import Delivery from "./SearchComponent/Delivery";
const StyledFilterPage = styled.div`
    &.frame-295922566,
    &.frame-295922566 * {
        box-sizing: border-box;
    }
    &.frame-295922566 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        margin-bottom: 30px;
    }
    .frame-295922565 {
        display: flex;
        gap: 8px;
        justify-content: flex-start;
        flex-wrap: wrap;
    }
    .frame-295922544 {
        background: #141414;
        border-radius: 43px;
        border-style: solid;
        border-color: #f7665f;
        border-width: 1px;
        padding: 0px 16px 0px 16px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 48px;
        position: relative;
        cursor: pointer;
    }
    .images-posts {
        text-align: center;
        font-family: var(--button-text-large-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var(--button-text-large-semibold-font-size, 16px);
        line-height: var(--button-text-large-semibold-line-height, 24px);
        font-weight: var(--button-text-large-semibold-font-weight, 600);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .images-posts-span {
        color: #ffffff;
        font-family: var(--button-text-large-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var(--button-text-large-semibold-font-size, 16px);
        line-height: var(--button-text-large-semibold-line-height, 24px);
        font-weight: var (--button-text-large-semibold-font-weight, 600);
    }
    .images-posts-span2 {
        color: var(--text-text-brand, #7745e0);
        font-family: var(--button-text-large-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var(--button-text-large-semibold-font-size, 16px);
        line-height: var (--button-text-large-semibold-line-height, 24px);
        font-weight: var(--button-text-large-semibold-font-weight, 600);
    }
    .chevron-right {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-295922543 {
        background: #141414;
        border-radius: 43px;
        border-style: solid;
        border-color: #7745e0;
        border-width: 1px;
        padding: 0px 16px 0px 16px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 48px;
        position: relative;
    }
    .frame-295922536.active {
        border-radius: 43px;
        border-style: solid;
        border-color: #f7665f;
        border-width: 1px;
    }
    .frame-1000011150 {
        border-radius: 50px;
        border-style: solid;
        border-color: #f7665f;
        border-width: 1px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        position: relative;
    }
    .x-close {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .brand-samsoe-samsoe {
        text-align: center;
        font-family: var(--button-text-large-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var (--button-text-large-semibold-font-size, 16px);
        line-height: var (--button-text-large-semibold-line-height, 24px);
        font-weight: var (--button-text-large-semibold-font-weight, 600);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .brand-samsoe-samsoe-span {
        color: #ffffff;
        font-family: var (--button-text-large-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var (--button-text-large-semibold-font-size, 16px);
        line-height: var (--button-text-large-semibold-line-height, 24px);
        font-weight: var (--button-text-large-semibold-font-weight, 600);
    }
    .brand-samsoe-samsoe-span2 {
        color: var (--text-text-brand, #7745e0);
        font-family: var (--button-text-large-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var (--button-text-large-semibold-font-size, 16px);
        line-height: var (--button-text-large-semibold-line-height, 24px);
        font-weight: var (--button-text-large-semibold-font-weight, 600);
    }
    .chevron-right2 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-295922536 {
        background: #141414;
        border-radius: 43px;
        padding: 0px 16px 0px 16px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 48px;
        position: relative;
        cursor: pointer;
    }
    .gender-both {
        text-align: center;
        font-family: var(--button-text-large-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var(--button-text-large-semibold-font-size, 16px);
        line-height: var (--button-text-large-semibold-line-height, 24px);
        font-weight: var (--button-text-large-semibold-font-weight, 600);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
    }
    .gender-both-span {
        color: #ffffff;
        font-family: "OpenSans-SemiBold", sans-serif;
        font-size: 14px;
        line-height: 24px;
        font-weight: 400;
    }
    .gender-both-span2 {
        color: #f7665f;
        font-family: "OpenSans-SemiBold", sans-serif;
        font-size: 14px;
        line-height: 24px;
        font-weight: 400;
    }
    .chevron-right3 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-295922542 {
        background: #141414;
        border-radius: 43px;
        padding: 0px 16px 0px 16px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 48px;
        position: relative;
        cursor: pointer;
    }
    .age-group-all {
        text-align: center;
        font-family: var(--button-text-large-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var (--button-text-large-semibold-font-size, 16px);
        line-height: var (--button-text-large-semibold-line-height, 24px);
        font-weight: var (--button-text-large-semibold-font-weight, 600);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .age-group-all-span {
        color: #ffffff;
        font-family: var (--button-text-large-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var (--button-text-large-semibold-font-size, 16px);
        line-height: var (--button-text-large-semibold-line-height, 24px);
        font-weight: var (--button-text-large-semibold-font-weight, 600);
    }
    .age-group-all-span2 {
        color: #7745e0;
        font-family: var (--button-text-large-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var (--button-text-large-semibold-font-size, 16px);
        line-height: var (--button-text-large-semibold-line-height, 24px);
        font-weight: var (--button-text-large-semibold-font-weight, 600);
    }
    .chevron-right4 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-295922538 {
        background: #141414;
        border-radius: 43px;
        padding: 0px 16px 0px 16px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 48px;
        position: relative;
    }
    .product-category-all {
        text-align: center;
        font-family: var(--button-text-large-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var (--button-text-large-semibold-font-size, 16px);
        line-height: var (--button-text-large-semibold-line-height, 24px);
        font-weight: var (--button-text-large-semibold-font-weight, 600);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .product-category-all-span {
        color: #ffffff;
        font-family: var (--button-text-large-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var (--button-text-large-semibold-font-size, 16px);
        line-height: var (--button-text-large-semibold-line-height, 24px);
        font-weight: var (--button-text-large-semibold-font-weight, 600);
    }
    .product-category-all-span2 {
        color: var (--text-text-brand, #7745e0);
        font-family: var (--button-text-large-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var (--button-text-large-semibold-font-size, 16px);
        line-height: var (--button-text-large-semibold-line-height, 24px);
        font-weight: var (--button-text-large-semibold-font-weight, 600);
    }
    .chevron-right5 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-295922545 {
        background: #141414;
        border-radius: 43px;
        padding: 0px 16px 0px 16px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 48px;
        position: relative;
    }
    .product-type-all {
        text-align: center;
        font-family: var (--button-text-large-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var (--button-text-large-semibold-font-size, 16px);
        line-height: var (--button-text-large-semibold-line-height, 24px);
        font-weight: var (--button-text-large-semibold-font-weight, 600);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .product-type-all-span {
        color: #ffffff;
        font-family: var (--button-text-large-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var (--button-text-large-semibold-font-size, 16px);
        line-height: var (--button-text-large-semibold-line-height, 24px);
        font-weight: var (--button-text-large-semibold-font-weight, 600);
    }
    .product-type-all-span2 {
        color: var (--text-text-brand, #7745e0);
        font-family: var (--button-text-large-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var (--button-text-large-semibold-font-size, 16px);
        line-height: var (--button-text-large-semibold-line-height, 24px);
        font-weight: var (--button-text-large-semibold-font-weight, 600);
    }
    .chevron-right6 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-295922537 {
        background: #141414;
        border-radius: 43px;
        padding: 0px 16px 0px 16px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 48px;
        position: relative;
    }
    .color-all {
        text-align: center;
        font-family: var (--button-text-large-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var (--button-text-large-semibold-font-size, 16px);
        line-height: var (--button-text-large-semibold-line-height, 24px);
        font-weight: var (--button-text-large-semibold-font-weight, 600);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .color-all-span {
        color: #ffffff;
        font-family: var (--button-text-large-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var (--button-text-large-semibold-font-size, 16px);
        line-height: var (--button-text-large-semibold-line-height, 24px);
        font-weight: var (--button-text-large-semibold-font-weight, 600);
    }
    .color-all-span2 {
        color: var (--text-text-brand, #7745e0);
        font-family: var (--button-text-large-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var (--button-text-large-semibold-font-size, 16px);
        line-height: var (--button-text-large-semibold-line-height, 24px);
        font-weight: var (--button-text-large-semibold-font-weight, 600);
    }
    .chevron-right7 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    @media (max-width: 992px) {
        .frame-295922536 {
            height: 40px;
            gap: 5px;
        }
        .gender-both,
        .gender-both-span,
        .gender-both-span2 {
            font-size: 12px;
            line-height: 20px;
        }
    }

    .group-selection.disable {
        opacity: 0.5;
        cursor: not-allowed !important;
    }

    .group-selection.disable .frame-295922536 {
        cursor: not-allowed !important;
    }
`;
const StyledTypePage = styled.div`
    &.dropdown-mini,
    &.dropdown-mini * {
        box-sizing: border-box;
    }
    &.dropdown-mini {
        background: #212121;
        border-radius: 5.6px;
        padding: 11.2px 5.6px 11.2px 5.6px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        width: 245px;
        position: absolute;
        box-shadow: 0px 0px 14px 0px rgba(17, 22, 32, 1);
        top: 55px;
        z-index: 9;
        max-height: 288px;
        overflow: scroll;
    }
    .frame-75 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313638 {
        display: flex;
        flex-direction: row;
        gap: 11.2px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .all {
        color: var (--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .check {
        flex-shrink: 0;
        width: 17.6px;
        height: 17.6px;
        position: relative;
        overflow: visible;
    }
    .frame-84 {
        border-radius: 5.6px;
        padding: 11.2px;
        display: flex;
        flex-direction: row;
        gap: 11.2px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        cursor: pointer;
    }
    .frame-84:hover {
        background: var (--surface-surface-tertiary-hover, #282828);
    }
    .frame-313639 {
        display: flex;
        flex-direction: row;
        gap: 11.2px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .b-oimages {
        color: var (--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .checkbox {
        height: 17.59px;
        width: 17.59px;
        border: 1px solid rgb(140, 143, 147);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    @media (max-width: 992px) {
        &.dropdown-mini.mini-type {
            top: 40px;
            left: 10px;
        }
        &.dropdown-mini.mini-brand {
            right: 10px;
            top: 40px;
        }
    }
    &::-webkit-scrollbar {
        width: 8px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #888;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #555;
    }
`;

export default function SearchPageFilter({ searchFunction }) {
    /* #region PROPS */
    const hideImages = false;
    const hideBrands = false;
    const hideGender = true;
    const hideAgeGroup = true;
    const hideProductCategory = true;
    const hideProductType = true;
    const hideColor = true;
    const hidePriceRange = true;
    const hideDelivery = true;
    /* #endregion */

    /* #region VARS */
    const navigate = useNavigate();
    const {
        selectedType,
        setSelectedType,
        selectedGender,
        setSelectedGender,
        selectedAgeGroup,
        setSelectedAgeGroup,
        showImageType,
        setShowImageType,
        showGenderFilter,
        setShowGenderFilter,
        showAgeGroupFilter,
        setShowAgeGroupFilter,
        selectedColor,
        setSelectedColor,
        setSelectedGroup,
        showColorFilter,
        setShowColorFilter,
        selectedBrands,
        setSelectedBrands,
        activeBrandList,
        showBrandFilter,
        setShowBrandFilter,
        selectedProductType,
        setSelectedProductType,
        setSelectedTypes,
        showProductType,
        setShowProductType,
        selectedProductCategory,
        setSelectedProductCategory,
        showProductCategory,
        setShowProductCategory,
        selectedDeliveryType,
        setSelectedDeliveryType,
        showDeliveryFilter,
        setShowDeliveryFilter,
        triggerSearch,
        setTriggerSearch,
        isSearchByAi
    } = useContext(LayoutContext);

    const imageFilterOptionData = [
        {
            id: "Posts",
            name: "Posts"
        },
        {
            id: "Products",
            name: "Products"
        }
    ];

    //const [triggerSearch, setTriggerSearch] = useState(false);
    /* #endregion */

    /* #region METHODS */
    const updateUrlParam = (param, value) => {
        const searchParams = new URLSearchParams(window.location.search);
        if (value === "Both" || value === "All") {
            searchParams.delete(param);
        } else {
            searchParams.set(param, value);
        }
        navigate({ search: searchParams.toString() });
    };

    const toggleColorSelection = color => {
        let updatedColors;
        if (color === "All") {
            updatedColors = [];
        } else {
            const currentColors = Array.isArray(selectedColor) ? selectedColor : [];
            updatedColors = currentColors.includes(color)
                ? currentColors.filter(c => c !== color)
                : [...currentColors.filter(c => c !== "All"), color];
        }
        setSelectedColor(updatedColors);
        updateUrlParam("color", updatedColors.join(","));
    };

    const getColorDisplayText = () => {
        if (!Array.isArray(selectedColor) || selectedColor.length === 0) return "All";
        const colorNames = selectedColor.map(colorCode => {
            const color = colorList.find(c => c.hex_code === colorCode);
            return color ? color.color_name : colorCode;
        });

        if (colorNames.length <= 2) return colorNames.join(", ");
        return `${colorNames.slice(0, 2).join(", ")} and +${colorNames.length - 2} more`;
    };

    const toggleBrandSelection = brandId => {
        let updatedBrands;
        if (brandId === "all") {
            updateUrlParam("brands", "All");
            updatedBrands = [];
            //updatedBrands = selectedBrands.length === activeBrandList.length ? [] : activeBrandList.map(brand => brand._id);
        } else {
            updatedBrands =
                Array.isArray(selectedBrands) && selectedBrands.includes(brandId)
                    ? selectedBrands.filter(id => id !== brandId)
                    : [...(Array.isArray(selectedBrands) ? selectedBrands.filter(id => id !== "all") : []), brandId];
        }
        setSelectedBrands(updatedBrands);
        if (updatedBrands.length === 0) {
            updateUrlParam("brands", "All");
        } else {
            updateUrlParam("brands", updatedBrands.join(","));
        }
    };

    const getBrandDisplayText = () => {
        try {
            if (!Array.isArray(selectedBrands) || selectedBrands.length === 0) return "All";
            const brandNames = selectedBrands.map(brandId => {
                const brand = activeBrandList.find(b => b._id === brandId);
                return brand ? brand.name : brandId;
            });

            if (brandNames.length <= 2) return brandNames.join(", ");
            return `${brandNames.slice(0, 2).join(", ")} and +${brandNames.length - 2} more`;
        } catch (e) {
            console.log("Error in getBrandDisplayText:", e);
        }
    };

    const toggleProductTypeSelection = type => {
        let updatedTypes;
        if (type === "All") {
            updateUrlParam("productType", "All");
            updatedTypes = [];
        } else {
            const currentTypes = Array.isArray(selectedProductType) ? selectedProductType : [];
            updatedTypes = currentTypes.includes(type)
                ? currentTypes.filter(t => t !== type)
                : [...currentTypes.filter(t => t !== "All"), type];
        }
        setSelectedProductType(updatedTypes);
        if (updatedTypes.length === 0) {
            updateUrlParam("productType", "All");
        } else {
            updateUrlParam("productType", updatedTypes.join(","));
        }
    };

    const getProductTypeDisplayText = () => {
        if (!Array.isArray(selectedProductType) || selectedProductType.length === 0) return "All";
        if (selectedProductType.length <= 2) return selectedProductType.join(", ");
        return `${selectedProductType.slice(0, 2).join(", ")} and +${selectedProductType.length - 2} more`;
    };

    const toggleProductCategorySelection = category => {
        let updatedCategories;
        if (category === "All") {
            updatedCategories = [];
        } else {
            const currentCategories = Array.isArray(selectedProductCategory) ? selectedProductCategory : [];
            updatedCategories = currentCategories.includes(category)
                ? currentCategories.filter(c => c !== category)
                : [...currentCategories.filter(c => c !== "All"), category];
        }
        setSelectedProductCategory(updatedCategories);
        if (updatedCategories.length === 0) {
            updateUrlParam("productCategory", "All");
        } else {
            updateUrlParam("productCategory", updatedCategories.join(","));
        }
    };

    const getProductCategoryDisplayText = () => {
        if (!Array.isArray(selectedProductCategory) || selectedProductCategory.length === 0) return "All";
        if (selectedProductCategory.length <= 2) return selectedProductCategory.join(", ");
        return `${selectedProductCategory.slice(0, 2).join(", ")} and +${selectedProductCategory.length - 2} more`;
    };

    const toggleDeliveryTypeSelection = type => {
        let updatedTypes;
        if (type === "All") {
            updatedTypes = [];
        } else {
            const currentTypes = Array.isArray(selectedDeliveryType) ? selectedDeliveryType : [];
            updatedTypes = currentTypes.includes(type)
                ? currentTypes.filter(t => t !== type)
                : [...currentTypes.filter(t => t !== "All"), type];
        }
        setSelectedDeliveryType(updatedTypes);
        if (updatedTypes.length === 0) {
            updateUrlParam("deliveryType", "All");
        } else {
            updateUrlParam("deliveryType", updatedTypes.join(","));
        }
    };

    const getDeliveryTypeDisplayText = () => {
        if (!Array.isArray(selectedDeliveryType) || selectedDeliveryType.length === 0) return "All";
        if (selectedDeliveryType.length <= 2) return selectedDeliveryType.join(", ");
        return `${selectedDeliveryType.slice(0, 2).join(", ")} and +${selectedDeliveryType.length - 2} more`;
    };

    const getSelectedTypesDisplay = selectedTypes => {
        if (selectedTypes.length <= 2) {
            return selectedTypes.join(", ");
        }
        return `${selectedTypes.slice(0, 2).join(", ")} +${selectedTypes.length - 2} more`;
    };
    /* #endregion */

    /* #region EFFECTS */
    useEffect(() => {
        // This triggers the search function when the triggerSearch state is set to true
        // This is helpful when we need to trigger the search function after other states
        // have been already updated and to avoid multiple calls to the search function
        if (!triggerSearch) return;
        setTriggerSearch(false);

        searchFunction({
            usePageLoading: true
        });
    }, [triggerSearch]);
    /* #endregion */

    return (
        <StyledFilterPage className="frame-295922566">
            <div className="frame-295922565">
                <div
                    className={`group-selection ${hideImages || isSearchByAi ? "disable" : ""}`}
                    onClick={e => {
                        e.stopPropagation();
                        setShowImageType(!showImageType);
                        setShowGenderFilter(false);
                        setShowAgeGroupFilter(false);
                        setShowColorFilter(false);
                        setShowBrandFilter(false);
                        setShowProductType(false);
                        setShowProductCategory(false);
                        setShowDeliveryFilter(false);
                    }}>
                    <div className="frame-295922536 active">
                        <div className="gender-both">
                            <span>
                                <span className="gender-both-span">Images:</span> <span className="gender-both-span2">{selectedType}</span>
                            </span>
                            <img
                                className="chevron-right"
                                src={SelectArrow}
                                alt="chevron-right0.svg"
                                style={{
                                    transform: showImageType && !hideImages && !isSearchByAi ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "transform 0.3s ease"
                                }}
                            />
                        </div>
                    </div>
                    {showImageType && !hideImages && !isSearchByAi && (
                        <DropDownComponent
                            selectedType={selectedType}
                            data={imageFilterOptionData}
                            onClick={id => {
                                setSelectedType(id);
                                setTriggerSearch(true);
                            }}
                        />
                    )}
                </div>

                <div className={`group-selection ${hideBrands || isSearchByAi ? "disable" : ""}`}>
                    <div className={`frame-295922536 ${getBrandDisplayText() !== "All" ? "active" : ""}`}>
                        {getBrandDisplayText() !== "All" && (
                            <div className="frame-1000011150">
                                <img
                                    className="x-close"
                                    src={ClearSearch}
                                    alt="ClearSearch"
                                    onClick={() => {
                                        if (!hideBrands && !isSearchByAi) {
                                            setSelectedBrands([]);
                                            updateUrlParam("brands", "All");
                                            setShowBrandFilter(false);
                                            setTriggerSearch(true);
                                        }
                                    }}
                                />
                            </div>
                        )}

                        <div
                            className="gender-both"
                            onClick={e => {
                                e.stopPropagation();
                                setShowImageType(false);
                                setShowGenderFilter(false);
                                setShowAgeGroupFilter(false);
                                setShowColorFilter(false);
                                setShowBrandFilter(!showBrandFilter);
                                setShowProductType(false);
                                setShowProductCategory(false);
                                setShowDeliveryFilter(false);
                            }}>
                            <span>
                                <span className="gender-both-span">Brand:</span>{" "}
                                <span className="gender-both-span2">{getBrandDisplayText()}</span>
                            </span>
                            <img
                                className="chevron-right2"
                                src={SelectArrow}
                                alt="chevron-right0.svg"
                                style={{
                                    transform: showBrandFilter && !hideBrands && !isSearchByAi ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "transform 0.3s ease"
                                }}
                            />
                        </div>
                    </div>
                    {showBrandFilter && !hideBrands && !isSearchByAi && (
                        <Brand
                            toggleBrandSelection={toggleBrandSelection}
                            selectedBrands={selectedBrands}
                            getBrandDisplayText={getBrandDisplayText}
                            setTriggerSearch={setTriggerSearch}
                        />
                    )}
                </div>

                <div className={`group-selection ${hideGender ? "disable" : ""}`}>
                    <div className={`frame-295922536 ${selectedGender !== "Both" ? "active" : ""}`}>
                        {selectedGender !== "Both" && (
                            <div
                                className="frame-1000011150"
                                onClick={() => {
                                    setSelectedGender("Both");
                                    updateUrlParam("gender", "Both");
                                    setShowGenderFilter(false);
                                    searchFunction();
                                }}>
                                <img className="x-close" src={ClearSearch} alt="ClearSearch" />
                            </div>
                        )}

                        <div
                            className="gender-both"
                            onClick={e => {
                                e.stopPropagation();
                                setShowImageType(false);
                                setShowGenderFilter(!showGenderFilter);
                                setShowAgeGroupFilter(false);
                                setShowColorFilter(false);
                                setShowBrandFilter(false);
                                setShowProductType(false);
                                setShowProductCategory(false);
                                setShowDeliveryFilter(false);
                            }}>
                            <span>
                                <span className="gender-both-span">Gender:</span>{" "}
                                <span className="gender-both-span2">{selectedGender}</span>
                            </span>
                            <img
                                className="chevron-right3"
                                src={SelectArrow}
                                alt="chevron-right0.svg"
                                style={{
                                    transform: showGenderFilter && !hideGender ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "transform 0.3s ease"
                                }}
                            />
                        </div>
                    </div>
                    {showGenderFilter && !hideGender && (
                        <GenderDropDownComponent
                            selectedType={selectedGender}
                            setSelectedType={setSelectedGender}
                            setShowImageType={setShowImageType}
                            setShowGenderFilter={setShowGenderFilter}
                            setShowAgeGroupFilter={setShowAgeGroupFilter}
                            searchFunction={searchFunction}
                        />
                    )}
                </div>

                <div className={`group-selection ${hideAgeGroup ? "disable" : ""}`}>
                    <div className={`frame-295922536 ${!selectedAgeGroup.includes("All") ? "active" : ""}`}>
                        {!selectedAgeGroup.includes("All") && (
                            <div
                                className="frame-1000011150"
                                onClick={() => {
                                    setSelectedAgeGroup(["All"]);
                                    updateUrlParam("agegroup", "All");
                                    setShowAgeGroupFilter(false);
                                    searchFunction();
                                }}>
                                <img className="x-close" src={ClearSearch} alt="ClearSearch" />
                            </div>
                        )}
                        <div
                            className="gender-both"
                            onClick={e => {
                                e.stopPropagation();
                                setShowImageType(false);
                                setShowGenderFilter(false);
                                setShowAgeGroupFilter(!showAgeGroupFilter);
                                setShowColorFilter(false);
                                setShowBrandFilter(false);
                                setShowProductType(false);
                                setShowProductCategory(false);
                                setShowDeliveryFilter(false);
                            }}>
                            <span>
                                <span className="gender-both-span">Age group:</span>{" "}
                                <span className="gender-both-span2">{getSelectedTypesDisplay(selectedAgeGroup)}</span>
                            </span>
                            <img
                                className="chevron-right4"
                                src={SelectArrow}
                                alt="chevron-right0.svg"
                                style={{
                                    transform: showAgeGroupFilter && !hideAgeGroup ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "transform 0.3s ease"
                                }}
                            />
                        </div>
                    </div>
                    {showAgeGroupFilter && !hideAgeGroup && (
                        <AgeGroup
                            selectedTypes={selectedAgeGroup}
                            setSelectedTypes={setSelectedAgeGroup}
                            setShowImageType={setShowImageType}
                            setShowGenderFilter={setShowGenderFilter}
                            setShowAgeGroupFilter={setShowAgeGroupFilter}
                            searchFunction={searchFunction}
                        />
                    )}
                </div>

                <div className={`group-selection ${hideProductCategory ? "disable" : ""}`}>
                    <div className={`frame-295922536 ${getProductCategoryDisplayText() !== "All" ? "active" : ""}`}>
                        {getProductCategoryDisplayText() !== "All" && (
                            <div className="frame-1000011150">
                                <img
                                    className="x-close"
                                    src={ClearSearch}
                                    alt="ClearSearch"
                                    onClick={() => {
                                        setSelectedProductCategory([]);
                                        updateUrlParam("productCategory", "All");
                                    }}
                                />
                            </div>
                        )}
                        <div
                            className="gender-both"
                            onClick={e => {
                                e.stopPropagation();
                                setShowImageType(false);
                                setShowGenderFilter(false);
                                setShowAgeGroupFilter(false);
                                setShowColorFilter(false);
                                setShowBrandFilter(false);
                                setShowProductType(false);
                                setShowProductCategory(true);
                                setShowDeliveryFilter(false);
                            }}>
                            <span>
                                <span className="gender-both-span">Product category:</span>{" "}
                                <span className="gender-both-span2">{getProductCategoryDisplayText()}</span>
                            </span>
                            <img
                                className="chevron-right6"
                                src={SelectArrow}
                                alt="chevron-right0.svg"
                                style={{
                                    transform: showProductCategory && !hideProductCategory ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "transform 0.3s ease"
                                }}
                            />
                        </div>
                    </div>
                    {showProductCategory && !hideProductCategory && (
                        <ProductCategory
                            toggleProductCategorySelection={toggleProductCategorySelection}
                            selectedProductCategory={selectedProductCategory}
                            getProductCategoryDisplayText={getProductCategoryDisplayText}
                            setShowProductCategory={setShowProductCategory}
                        />
                    )}
                </div>

                <div className={`group-selection ${hideProductType ? "disable" : ""}`}>
                    <div className={`frame-295922536 ${getProductTypeDisplayText() !== "All" ? "active" : ""}`}>
                        {getProductTypeDisplayText() !== "All" && (
                            <div className="frame-1000011150">
                                <img
                                    className="x-close"
                                    src={ClearSearch}
                                    alt="ClearSearch"
                                    onClick={() => {
                                        setSelectedProductType([]);
                                        setSelectedTypes(["All"]);
                                        updateUrlParam("productType", "All");
                                    }}
                                />
                            </div>
                        )}
                        <div
                            className="gender-both"
                            onClick={e => {
                                e.stopPropagation();
                                setShowImageType(false);
                                setShowGenderFilter(false);
                                setShowAgeGroupFilter(false);
                                setShowColorFilter(false);
                                setShowBrandFilter(false);
                                setShowProductType(true);
                                setShowProductCategory(false);
                                setShowDeliveryFilter(false);
                            }}>
                            <span>
                                <span className="gender-both-span">Product type:</span>{" "}
                                <span className="gender-both-span2">{getProductTypeDisplayText()}</span>
                            </span>
                            <img
                                className="chevron-right5"
                                src={SelectArrow}
                                alt="chevron-right0.svg"
                                style={{
                                    transform: showProductType && !hideProductType ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "transform 0.3s ease"
                                }}
                            />
                        </div>
                    </div>
                    {showProductType && !hideProductType && (
                        <ProductType toggleProductTypeSelection={toggleProductTypeSelection} selectedType={selectedProductType} />
                    )}
                </div>

                <div className={`group-selection ${hideColor ? "disable" : ""}`}>
                    <div className={`frame-295922536 ${getColorDisplayText() !== "All" ? "active" : ""}`}>
                        {getColorDisplayText() !== "All" && (
                            <div
                                className="frame-1000011150"
                                onClick={() => {
                                    setSelectedColor("All");
                                    updateUrlParam("color", "All");
                                }}>
                                <img className="x-close" src={ClearSearch} alt="ClearSearch" />
                            </div>
                        )}
                        <div
                            className="gender-both"
                            onClick={e => {
                                e.stopPropagation();
                                setShowImageType(false);
                                setShowGenderFilter(false);
                                setShowAgeGroupFilter(false);
                                setShowColorFilter(true);
                                setShowBrandFilter(false);
                                setShowProductType(false);
                                setShowProductCategory(false);
                                setShowDeliveryFilter(false);
                            }}>
                            <span>
                                <span className="gender-both-span">Color:</span>{" "}
                                <span className="gender-both-span2">{getColorDisplayText()}</span>
                            </span>
                            <img
                                className="chevron-right7"
                                src={SelectArrow}
                                alt="chevron-right0.svg"
                                style={{
                                    transform: showColorFilter && !hideColor ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "transform 0.3s ease"
                                }}
                            />
                        </div>
                    </div>
                    {showColorFilter && !hideColor && (
                        <Color
                            selectedType={selectedType}
                            setSelectedType={setSelectedType}
                            selectedColor={selectedColor}
                            setSelectedGroup={setSelectedGroup}
                            setShowColorFilter={setShowColorFilter}
                            toggleColorSelection={toggleColorSelection}
                            colorList={colorList}
                        />
                    )}
                </div>

                <div className={`group-selection ${hidePriceRange ? "disable" : ""}`}>
                    <div className="frame-295922536">
                        <div className="gender-both">
                            <span>
                                <span className="gender-both-span">Price Range:</span> <span className="gender-both-span2">All</span>
                            </span>
                            <img
                                className="chevron-right6"
                                src={SelectArrow}
                                alt="chevron-right0.svg"
                                style={{
                                    //TODO: transform: showPriceRange && !hidePriceRange ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "transform 0.3s ease"
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className={`group-selection ${hideDelivery ? "disable" : ""}`}>
                    <div className={`frame-295922536 ${getDeliveryTypeDisplayText() !== "All" ? "active" : ""}`}>
                        {getDeliveryTypeDisplayText() !== "All" && (
                            <div
                                className="frame-1000011150"
                                onClick={() => {
                                    setSelectedDeliveryType([]);
                                    updateUrlParam("deliveryType", "All");
                                }}>
                                <img className="x-close" src={ClearSearch} alt="ClearSearch" />
                            </div>
                        )}
                        <div
                            className="gender-both"
                            onClick={e => {
                                e.stopPropagation();
                                setShowImageType(false);
                                setShowGenderFilter(false);
                                setShowAgeGroupFilter(false);
                                setShowColorFilter(false);
                                setShowBrandFilter(false);
                                setShowProductType(false);
                                setShowProductCategory(false);
                                setShowDeliveryFilter(true);
                            }}>
                            <span>
                                <span className="gender-both-span">Delivery:</span>{" "}
                                <span className="gender-both-span2">{getDeliveryTypeDisplayText()}</span>
                            </span>
                            <img
                                className="chevron-right6"
                                src={SelectArrow}
                                alt="chevron-right0.svg"
                                style={{
                                    transform: showDeliveryFilter && !hideDelivery ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "transform 0.3s ease"
                                }}
                            />
                        </div>
                    </div>
                    {showDeliveryFilter && !hideDelivery && (
                        <Delivery
                            toggleDeliveryTypeSelection={toggleDeliveryTypeSelection}
                            selectedDeliveryType={selectedDeliveryType}
                            setShowDeliveryFilter={setShowDeliveryFilter}
                        />
                    )}
                </div>
            </div>
        </StyledFilterPage>
    );
}
const DropDownComponent = ({ selectedType, data, onClick }) => {
    return (
        <StyledTypePage className="dropdown-mini mini-type">
            <div className="frame-75">
                {data.map((v, i) => (
                    <div key={i} className="frame-84" onClick={() => onClick(v.id)}>
                        <div className="frame-313639">
                            <div className="checkbox">
                                {selectedType === v.id && <img className="check" src={SelectedTick} alt="check1.svg" />}
                            </div>
                            <div className="b-oimages">{v.name}</div>
                        </div>
                    </div>
                ))}
            </div>
        </StyledTypePage>
    );
};
export const colorList = [
    { color_name: "Red", hex_code: "#FF0000" },
    { color_name: "Green", hex_code: "#008000" },
    { color_name: "Blue", hex_code: "#0000FF" },
    { color_name: "Yellow", hex_code: "#FFFF00" },
    { color_name: "Cyan", hex_code: "#00FFFF" },
    { color_name: "Magenta", hex_code: "#FF00FF" },
    { color_name: "Orange", hex_code: "#FFA500" },
    { color_name: "Purple", hex_code: "#800080" },
    { color_name: "Pink", hex_code: "#FFC0CB" },
    { color_name: "Brown", hex_code: "#A52A2A" },
    { color_name: "Black", hex_code: "#000000" },
    { color_name: "White", hex_code: "#FFFFFF" }
];
